import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../../auth/jwt.service';
import { DataSharingService } from '../../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AdmindashboardService {

  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) { }
    getPurchaseOrders()
    {
      return this.http.get(this.rootUrl + '/api/Dashboard/AdminDashboard/getPurchaseOrders/');
    }
    getNewVendors()
    {
      return this.http.get(this.rootUrl + '/api/Dashboard/AdminDashboard/getNewVendors/');

    }
    getMessageCount()
    {
      return this.http.get(this.rootUrl + '/api/Dashboard/AdminDashboard/getMessageCount/');
    }
    userRoleProvided() {

      return this.http.get(this.rootUrl + '/api/account/userRoleProvided/');
    }
    adminmessagesend(form)
    {
     debugger;
      return this.http.post(this.rootUrl + '/api/Dashboard/AdminDashboard/adminmessagesend/',form);
    }
    vendormessagesend(form)
    {
     debugger;
      return this.http.post(this.rootUrl + '/api/Dashboard/AdminDashboard/vendormessagesend/',form);
    }

    GetRollsList(){
      return this.http.get(this.rootUrl + '/api/Dashboard/AdminDashboard/GetRollsList');
    }
    GetMessagelist(){
      return this.http.get(this.rootUrl + '/api/Dashboard/AdminDashboard/GetMessagelist');
    }
}
